function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import formMessages from 'components/Form/messages';
import ErrorIcon from 'svg/error.svg';
import { FILE_MAX_SIZE, FILE_VALID_TYPES, CONTAINER_SIDE, CROP_BORDER } from '../variables';
import styles from '../AvatarCropModal.pcss';
import { getSizeWithUnit } from './helpers';
const errorsMessages = _object_spread({}, formMessages.uploaderMessages.errors);
const ImageInput = ({ isRound, setImageSrc })=>{
    const [dragEnter, setDragEnter] = useState(false);
    const [error, setError] = useState(null);
    const [errorParams, setErrorParams] = useState([]);
    const validateAndUploadFile = async (file)=>{
        if (!file) return;
        const fileValidTypes = FILE_VALID_TYPES.map((f)=>`image/${f}`);
        if (!fileValidTypes.includes(file.type)) {
            setError('acceptFileTypes');
            setErrorParams([
                fileValidTypes.join(', ')
            ]);
            return;
        }
        if (file.size > FILE_MAX_SIZE) {
            const maxSize = getSizeWithUnit(FILE_MAX_SIZE);
            setError('maxSize');
            setErrorParams([
                maxSize
            ]);
            return;
        }
        setError(null);
        setErrorParams([]);
        const imageDataUrl = URL.createObjectURL(file);
        setImageSrc(imageDataUrl);
    };
    const onDragEnter = (evt)=>{
        setDragEnter(true);
        evt.preventDefault();
        evt.stopPropagation();
    };
    const onDragLeave = (evt)=>{
        setDragEnter(false);
        evt.preventDefault();
        evt.stopPropagation();
    };
    const onDragOver = (evt)=>evt.preventDefault();
    const onDrop = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        const file = evt.dataTransfer.files[0];
        setDragEnter(false);
        validateAndUploadFile(file);
    };
    const onFileChange = (evt)=>{
        if (evt.target.files && evt.target.files.length > 0) {
            const file = evt.target.files[0];
            validateAndUploadFile(file);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, formMessages.uploaderMessages.infos.upload), {
                    values: {
                        fileTypes: FILE_VALID_TYPES.map((f)=>`.${f}`).join(', '),
                        size: getSizeWithUnit(FILE_MAX_SIZE)
                    }
                }))
            }),
            /*#__PURE__*/ _jsxs("label", {
                className: cn(styles.container, styles.uploadBox, {
                    [styles['container--round']]: isRound
                }),
                style: {
                    width: CONTAINER_SIDE,
                    height: CONTAINER_SIDE,
                    borderWidth: CROP_BORDER
                },
                onDragEnter: onDragEnter,
                onDragLeave: onDragLeave,
                onDragOver: onDragOver,
                onDrop: onDrop,
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        onChange: onFileChange,
                        accept: "image/*",
                        hidden: true
                    }),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, formMessages.uploaderMessages.labels[dragEnter ? 'drop' : 'upload']), {
                        values: {
                            br: /*#__PURE__*/ _jsx("br", {})
                        }
                    }))
                ]
            }),
            error && /*#__PURE__*/ _jsxs("div", {
                className: "form-text form-error mt-6",
                children: [
                    /*#__PURE__*/ _jsx(ErrorIcon, {
                        className: "form-error-icon"
                    }),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, errorsMessages[error]), {
                        values: errorParams
                    }))
                ]
            }, error)
        ]
    });
};
export default ImageInput;
